import styled from "styled-components";

import Title from "../components/Title";
import Paragraph from "../components/Paragraph";
import LinkIcon from "../components/LinkIcon";
import cv from "../assets/cv.pdf"
import bluesky from "../assets/bluesky_logo.png"
import email from "../assets/email_logo.png"
import github from "../assets/github_logo.png"
import linkedin from "../assets/linkedin_logo.png"

const Link = styled.a`
    color: rgb(147, 225, 237);
    text-decoration: none;
    font-weight: bold;
`;

const LinkIconsContainer = styled.div`
    display: flex;
    gap: 10px;
`

function calculateAge(birthday) {
  var timeAlive = new Date(Date.now() - birthday)
  return Math.abs(timeAlive.getUTCFullYear() - 1970)
}

function AboutMe(){
    return(
      <>
        <Title text="About Me" fontSize={5}/>
        <Paragraph fontSize={2.2} maxWidth={80}>
          Hi! I'm a {calculateAge(new Date(2005, 5, 1))}-year-old Computer Science student in my final year, with a strong focus on .NET.
          I'm passionate about creation. I make all kinds of stuff, and I enjoy the process.
        </Paragraph>
        <Paragraph fontSize={2.2} maxWidth={80}>
          My interest in software comes from a love of problem solving, something I also explore through my
          hobbies like cars, psychology, and music. (You'll find my covers on the Music page.)
        </Paragraph>
        <Paragraph fontSize={2.2} maxWidth={80}>
          I've completed two internships and led team-based personal projects where I handled
          task planning and development cycles. I enjoy working in teams where I can help organize and
          track progress, but I'm just as comfortable working solo when needed.
        </Paragraph>
        <Paragraph fontSize={2.2} maxWidth={50}>
          If you're here for the CV, <Link href={cv} target="_blank">click here</Link>.   
          Otherwise, thanks for taking the time to read this.
        </Paragraph>
        <LinkIconsContainer>
          <LinkIcon imageSource={bluesky} link="https://bsky.app/profile/sapokee.bsky.social"/>
          <LinkIcon imageSource={email} link="mailto:lazarcata123@gmail.com"/>
          <LinkIcon imageSource={github} link="https://github.com/Sapokee"/>
          <LinkIcon imageSource={linkedin} link="https://www.linkedin.com/in/sapokee/"/>
        </LinkIconsContainer>
      </>
    )
}

export default AboutMe;